import { ReplicaType } from "types";
import Version0 from "./v0";
import Version1 from "./v1";
import Version2 from "./v2";
import Version3 from "./v3";
import Version4 from "./v4";
import Version5_0 from "./v5.0";
import Version5_1 from "./v5.1";
import Version5_2 from "./v5.2";
import Version6 from "./v6";
import Version7 from "./v7";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "marauders-map",
  name: `The Marauder's Map`,
  origin: "Harry Potter movies, books and my ideas",

  sort: {
    preferredIndex: 0,
  },

  category: replicaCategories.harryPotter,

  versions: [
    Version7,
    Version6,
    Version5_2,
    Version5_1,
    Version5_0,
    Version4,
    Version3,
    Version2,
    Version1,
    Version0,
  ],
};

export default data;
